import React from "react";
import styles from "./degreeSelect.module.scss";
import SelectInput from "features/shared/components/selectInput/SelectInput";
import DegreeDTO from "features/shared/dtos/DegreeDTO";
import { BindFieldFunction } from "features/shared/forms/hooks/useForm";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  degrees: DegreeDTO[];
  bindField: BindFieldFunction;
  isInFrontOfName: boolean;
  disabled?: boolean;
};

const DegreeSelect = ({
  name,
  degrees,
  bindField,
  isInFrontOfName,
  disabled
}: Props) => {
  //translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // render
  return (
    <SelectInput
      options={[
        { value: "" },
        ...degrees.filter((x) => x.isInFrontOfName === isInFrontOfName)
      ]}
      optionName="value"
      optionValue="value"
      defaultValueLabel={tLabels("degreeSelect.label")}
      {...bindField(name)}
      classNameSelect={styles.select}
      className="mb-0"
      disabled={disabled}
    />
  );
};

export default DegreeSelect;
